enum HelpMessageEnum {
  NO_RESULTS = "no_results",
  NO_CLASSES = "no_classes"
}
export default HelpMessageEnum;
